import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  path?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-2">
              {index > 0 && (
                <span className="w-4 h-4 flex items-center justify-center text-foreground-300">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              )}
              {item.path && !isLast ? (
                <Link to={item.path} className="hover:text-primary-600 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}